export const selectIADetails = state => {
  return state.iaDetails;
};